import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { CashRegisterReportFormModel } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): CashRegisterReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  cash_register_ids: null,
  cashier_ids: null,
  operation_id: null,
  file_type: 'pdf',
  with_details: false,
  with_exchange: false,
  closing_groupedby_group: true,
});
